import { useEffect, useImperativeHandle, useState, useRef, useMemo } from 'react';
/**
 * react aptor(api-connector) a hook which connect api to react itself
 * @param ref - react forwarded ref
 * @param {Object} configuration - configuration object for setup
 * @param {Array} [deps=[]] - react dependencies array
 * @return domRef - can be bound to dom element
 */
export default function useAptor(ref, configuration, deps) {
    if (deps === void 0) { deps = []; }
    var _a = useState(null), instance = _a[0], setInstance = _a[1];
    var domRef = useRef(null);
    var instantiate = configuration.instantiate, destroy = configuration.destroy, getAPI = configuration.getAPI, params = configuration.params;
    useEffect(function () {
        var instanceReference = instantiate(domRef.current, params);
        setInstance(instanceReference);
        return function () {
            if (destroy)
                destroy(instanceReference, params);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var api = useMemo(function () { return getAPI(instance, params); }, [instance]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useImperativeHandle(ref, api, [api]);
    return domRef;
}
